<div class="content" [ngClass]="{'show': isShow}">
    <div class="shadow" (click)="hideModal()">

    </div>
    <div class="sheet-modal">
        <div class="flex justify-content-between mb-2">
            <p-button [style.visibility]="isChildren ? 'visible' : 'hidden'" (click)="popModal()" icon="pi pi-angle-left" size="large"  [rounded]="true" [text]="true" [plain]="true"></p-button>
            <p-button (click)="hideModal()" icon="pi pi-times" [rounded]="true" [text]="true" [plain]="true"></p-button>
        </div>
        <ng-content *ngIf="loading == false">

        </ng-content>
        <div class="h-full relative">
             <split-loading [loading]="loading"></split-loading>
        </div>
    </div>
</div>

